module.exports = __webpack_public_path__ + "img/38.0a7746e2.jpg";